import script from "./AssessmentSpaces.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentSpaces.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentSpaces.vue?vue&type=style&index=0&id=1bf26b71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf26b71"]])

export default __exports__